import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const helpOptions = [
  {
    label: 'Submit a dashboard request',
    tooltip: 'Submit a request for a new dashboard or enhancements to an existing one.',
    link: 'https://forms.office.com/pages/responsepage.aspx?id=OjzpYnxwj0mjyUMjnlOuAU4FSMaDi6tPs5Nhz5b53qtUMkc5NUM4MlJJQkVENFgxMDlVVzBMSFJXWi4u&route=shorturl',
    icon: ['fal', 'clipboard-list']
  },
  {
    label: 'Book a support session',
    tooltip: 'Schedule a session with the Analytics for Schools team for tailored support.',
    link: 'https://outlook.office.com/book/BookatimewithAFSteam@analyticsforschools.com.au/?ismsaljsauthenabled',
    icon: ['fal', 'calendar-check']
  },
  {
    label: 'Learn about MAESTRO',
    tooltip: 'Browse guides, how-tos, and answers about using MAESTRO.',
    link: 'https://analyticsforschools.atlassian.net/wiki/spaces/MKB/overview',
    icon: ['fal', 'book-open']
  }
];

export default function HelpModal({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: '16px',
          minWidth: 360,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
          background: '#ffffff'
        }
      }}
    >
      <DialogTitle
        style={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: 22,
          color: '#ffffff', // Changed color to white for better contrast
          borderBottom: '1px solid #e0e0e0',
          paddingBottom: 12
        }}
      >
        Help & Support
      </DialogTitle>
      <DialogContent style={{ padding: '24px', background: '#f9f9f9' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 20 }}>
          {helpOptions.map((opt) => (
            <Tooltip key={opt.label} title={opt.tooltip} placement='right'>
              <a
                href={opt.link}
                target='_blank'
                rel='noopener noreferrer'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16,
                  background: '#ffffff',
                  borderRadius: 12,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  padding: '16px',
                  textDecoration: 'none',
                  color: '#424242',
                  fontWeight: 500,
                  fontSize: 16,
                  transition: 'transform 0.2s, box-shadow 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'scale(1.02)';
                  e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.15)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                }}
              >
                <FontAwesomeIcon icon={opt.icon} style={{ fontSize: 20, color: '#1976d2' }} />
                <span>{opt.label}</span>
              </a>
            </Tooltip>
          ))}
        </div>
      </DialogContent>
      <DialogActions
        style={{ justifyContent: 'center', background: '#f9f9f9', borderTop: '1px solid #e0e0e0' }}
      >
        <Button
          onClick={onClose}
          color='primary'
          variant='contained'
          style={{ fontWeight: 600, borderRadius: 8 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
